module.exports = __webpack_public_path__ + "img/erweima.cbe36433.jpg";